import { getWeatherDomainType } from "@/utils";

const DOMAIN_24HWEATHER = "24hweather.com";
const PRIVACY_POLICY_24HWEATHER = "https://www.24hweather.com/24hweather_privacy_policy.html";
const PRIVACY_POLICY_COMFORTWEATHER = "https://www.comfortweather.com/Privacy_Policy.html";

export function getPrivacyPolicyUrl(): string {
  const domainType = getWeatherDomainType();

  // 边界条件检查
  if (typeof domainType !== "string" || domainType.trim() === "") {
    throw new Error("Invalid domain type returned from getWeatherDomainType()");
  }

  // 条件判断
  return domainType === DOMAIN_24HWEATHER ? PRIVACY_POLICY_24HWEATHER : PRIVACY_POLICY_COMFORTWEATHER;
}
